module.exports = __webpack_public_path__ + "static/media/icon-balance.25d500b4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/icon-balance.svg
// module id = 1219
// module chunks = 19